import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function RestaurantHat(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M11.082 5.918c.05.065.1.131.146.198A1 1 0 119.586 7.26a2.903 2.903 0 00-.568-.608c-1.28-1.026-3.232-.813-4.349.58-1.117 1.393-.901 3.345.379 4.37a2.928 2.928 0 001.904.643 1 1 0 011.008.844 1 1 0 01.04.282V19a1 1 0 001 1h6a1 1 0 001-1v-3.29a6.948 6.948 0 01-1.984-.006 1 1 0 01.292-1.979 4.962 4.962 0 004.052-1.233c2.038-1.835 2.207-4.934.419-6.919-1.788-1.984-4.887-2.139-6.925-.303-.226.203-.53.453-.772.648zM18 15.11a7.017 7.017 0 001.698-1.133c2.84-2.557 3.111-6.918.567-9.743-2.544-2.825-6.91-3.008-9.75-.451-.187.169-.465.397-.707.592l-.28.223c-2.124-1.15-4.843-.585-6.419 1.38-1.767 2.204-1.505 5.425.688 7.183A4.9 4.9 0 006 14.165V19a3 3 0 003 3h6a3 3 0 003-3v-3.89z",
    clipRule: "evenodd"
  }));
}

export default RestaurantHat;